import * as yup from 'yup';
import { FIRST_NAME, LAST_NAME, PHONE, VALID_PHONE, VALID_PHONE_REGEX } from '../../constants/schemaForm.constants';

export const schemaSignUp = yup.object().shape({
  firstName: yup.string().required(FIRST_NAME),
  lastName: yup.string().required(LAST_NAME),
  phone: yup.string().trim().required(PHONE).matches(VALID_PHONE_REGEX, VALID_PHONE),
  email: yup.string().required().email(),
});
